import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-title">Developers</p>
        <p className="footer-desc">컴퓨터공학부 N-CUBE 여름방학 프로젝트 3팀</p>
      </div>
    </footer>
  );
};

export default Footer;